import {
  CentralModal,
  constants,
  ExpandableCard,
  Paragraph,
  Subheader,
  Title,
} from '@cambridgeassessment/cambridge-ui';
import {
  abbey,
  black,
  cherry,
  greyishBrown,
  iron,
  scienceBlue,
} from '@cambridgeassessment/cambridge-ui/build/abstracts/colours';
import { Table } from '@material-ui/core';
import styled from 'styled-components';

export const StyledSelectsRow = styled.div`
  display: flex;

  > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const StyledSampleCardWrapper = styled.div`
  padding: 16px 0;

  .MuiButtonBase-root {
    user-select: text;

    .MuiAccordionSummary-content {
      cursor: default;
    }
  }
`;

export const SelectTitleWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SampleCardSummary = styled.div`
  padding: 32px;
  width: 100%;
`;

export const TitleButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryTextParagraphs = styled.div`
  > :not(:last-child) {
    padding-bottom: 12px;
  }

  button {
    cursor: pointer;
  }
`;

export const StyledTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: 12px;
`;

export const StyledSubtitle = styled(Subheader)`
  color: ${greyishBrown};
  font-weight: bold;
`;

export const ExpandableCardStyled = styled(ExpandableCard)`
  .MuiAccordionSummary-root {
    &:hover {
      cursor: default;
      background-color: inherit;
    }
  }
`;

export const StyledTable = styled(Table)`
  padding-top: 16px;
`;

export const TitleIconWrapper = styled.div`
  display: inline-flex;

  > :first-child {
    margin-right: 16px;
  }
`;

export const CentralModalStyled = styled(CentralModal)`
  .MuiDialog-container {
    color: red;

    > :first-child {
      width: 100%;
    }
  }
`;

export const FixedScrollableHeight = styled.div`
  height: 310px;
  overflow-y: scroll;
`;

export const CheckboxStyled = styled.div`
  > span {
    padding: 0;
  }
`;

export const ModalTitleStyled = styled.div`
  font-size: 18px;
  color: ${black};
  font-weight: bold;
  padding-bottom: ${constants.MEDIUM};
`;

export const ModalSubtitleStyled = styled.div<{ noPadding?: boolean }>`
  font-size: ${constants.MEDIUM};
  color: ${black};
  text-align: left;
  padding-bottom: ${(props) => (props.noPadding ? '' : constants.MEDIUM)};
`;

export const LinkWrapper = styled.div`
  text-decoration: underline;
  font-size: ${constants.SMALL};
  cursor: pointer;
  color: ${scienceBlue};
`;

export const StyledRadioBtn = styled.div`
  span {
    padding: 0;
  }
`;

export const TableWrapper = styled.div`
  tbody {
    tr {
      td {
        &:first-child {
          padding: 0 ${constants.XSMALL};
        }
      }
    }
  }
`;
export const StyledTextarea = styled.textarea`
  border-radius: 10px;
  border: 2px solid ${iron};
  font-family: SourceSansPro;
  padding: 12px;
  outline: none;
  resize: none;
  width: 100%;
  min-height: 200px;
  font-size: ${constants.MEDIUM};

  &:focus {
    border: 2px solid ${scienceBlue};
  }
`;

export const FixedHeightModalContent = styled.div`
  min-height: 444px;
`;

export const MaxLengthDisclaimer = styled.div<{ warning: boolean }>`
  color: ${(props) => (props.warning ? cherry : abbey)};
  font-size: ${constants.SMALL};
  padding-left: ${constants.MEDIUM};
`;

export const StyledParagraph = styled(Paragraph)`
  font-weight: bold;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
